import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {UmpireSquadPlayer} from '@tisa-group/models';
import {ImageVariantModule} from '@tisa-group/core';
import {TranslateModule} from '@ngx-translate/core';
import {SvgIconComponent} from '@tisa-group/client-ui/components/svg-icon';

@Component({
  selector: 'tisa-player-tile',
  imports: [CommonModule, SvgIconComponent, ImageVariantModule, TranslateModule],
  templateUrl: './player-tile.component.html',
  styleUrl: './player-tile.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlayerTileComponent {
  squadPlayer = input<UmpireSquadPlayer>();
}
